import React from 'react'
import { strings } from '../../../localization/strings'
import ConfigPanel from './configPanel'
import Switch from '@material-ui/core/Switch'

const Component = ({ config, handleEdit }) => {
    return (
        <ConfigPanel
            title={strings.generalConfigTitle}
            items={[
                {
                    label: strings.generalConfigShowAddressInLabel,
                    control: (
                        <Switch
                            color="primary"
                            checked={config.showAddressInLabel}
                            onChange={(x) =>
                                handleEdit({
                                    wasEdited: true,
                                    config: {
                                        ...config,
                                        showAddressInLabel: x.target.checked,
                                    },
                                })
                            }
                            name="checkedA"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    ),
                },
            ]}
        />
    )
}

export default Component
